import { shallowRef } from 'vue';
import { defineStore } from 'pinia';

export const useMousePosition = defineStore('mouse-position', () => {
	const posX = shallowRef(null);
	const posY = shallowRef(null);

	const mouseEventHandler = (event) => {
		posY.value = event.clientY;
		posX.value = event.clientX;
	};

	return {
		posX,
		posY,

		mouseEventHandler
	};
});
